import React from 'react';
import { Form, Button } from 'antd';


const defaultProps = {
    children: 'Submit',
    wrapperCol: {},
};

const FormSubmitButton = ({ children, wrapperCol, ...rest }) => {
    return (
        <Form.Item wrapperCol={wrapperCol}>
            <Button type="primary" htmlType="submit" {...rest}>
                { children }
            </Button>
        </Form.Item>
    );
};

FormSubmitButton.defaultProps = defaultProps;

export default FormSubmitButton;
